import { css } from 'styled-components';
import { COLORS } from '../color';
import { remCalc } from '../typography/utils';

export const blackScrollbars = css`
  ::-webkit-scrollbar {
    width: ${remCalc(16)};
    background: transparent;
    border-radius: 100px;
  }

  ::-webkit-scrollbar-track {
    border-radius: ${remCalc(100)};
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${COLORS.BLACK};
    border: 2px solid transparent;
    border-radius: ${remCalc(100)};
    background-clip: content-box;
  }
`;

export const colorScrollbars = (color: string) => css`
  ::-webkit-scrollbar {
    width: ${remCalc(16)};
    background: ${COLORS.GRAY.HIGHLIGHT};
    border-radius: 100px;
  }

  ::-webkit-scrollbar-track {
    border-radius: ${remCalc(100)};
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb {
    background: ${color};
    border: 3px solid ${COLORS.GRAY.HIGHLIGHT};
    border-radius: ${remCalc(100)};
    background-clip: content-box;
  }
`;
